import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { getPlace, getPlaces, postPlace, putPlace } from '../../store/actions/place/place_action';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import TextInput from '../ui_components/text_input';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    typography: {
		margin: theme.spacing(3, 0, 2)
    },
    form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
        '& p': {
            color: '#bf1650',
            '&::before': {
                display: 'inline',
                content: '"⚠ "'
            }
        }
	}
}));

const Place = ({ places }) => {
    const { uuid } = useParams();
    const { container, typography, form } = useStyles();
    const { control, handleSubmit, reset, formState: { errors } } = useForm();
    const dispatch = useDispatch();

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        uuid && (async () => {
            reset(await getPlace(uuid));
        })();
        !places.collection.length && dispatch(getPlaces());
    }, [uuid]);

    const onSubmit = (data) => {
        if (uuid) {
            enqueueSnackbar(
                'Uspešno ste sačuvali mesto', {
                variant: 'success'
            });
            return dispatch(putPlace(uuid, data));
        }
        enqueueSnackbar(
            'Uspešno ste sačuvali mesto', {
            variant: 'success'
        });
        return dispatch(postPlace(data));
    }

    const handleClickBackToList = () => {
        history.push(REACT_ROUTES.PLACES);
    }

    return (
        <Container className={container}>
            <Typography align="center" variant="h4" className={typography}>Mesto</Typography>
            <Grid container justify="center" spacing={3}>
                <Grid item>
                    <Button
                        color="primary"
                        size="small"
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                        type="button"
                    >
                        Sačuvaj
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleClickBackToList}
                    >
                        Nazad
                    </Button>
                </Grid>
            </Grid>
            <form className={form}>
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={8}>
                        <TextInput
                            control={control}
                            name="name"
                            label="Naziv"
                            rules={{ required: 'Unesite naziv' }}
                        />
                        <ErrorMessage errors={errors} name="name" as="p" />
                    </Grid>
                    <Grid item xs={8}>
                        <TextInput
                            control={control}
                            name="address"
                            label="Adresa"
                        />
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}

Place.propTypes = {
    places: PropTypes.object
}

const mapStateToProps = (state) => ({
    places: state.places
});

export default connect(mapStateToProps)(Place);
